import mutationsTypes from '@/vuex/administracao/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_LISTA_ITENS_GLOSSARIO: 'GET_LISTA_ITENS_GLOSSARIO',
  GET_LISTA_TIPOS_DOCUMENTO_GLOSSARIO: 'GET_LISTA_TIPOS_DOCUMENTO_GLOSSARIO',
  CRIAR_ITEM_GLOSSARIO: 'CRIAR_ITEM_GLOSSARIO',
  EDITAR_ITEM_GLOSSARIO: 'EDITAR_ITEM_GLOSSARIO',
  EXCLUIR_ITEM_GLOSSARIO: 'EXCLUIR_ITEM_GLOSSARIO'
}

export default types
